import type { NavSectionProps } from '@classroom-ai/ui/components/nav-section';

import { SvgColor } from '@classroom-ai/ui/components/svg-color';

import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  params: icon('ic-params'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  subpaths: icon('ic-subpaths'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
};

// ----------------------------------------------------------------------

export const navData: NavSectionProps['data'] = [
  {
    items: [{ title: 'Dashboard', path: paths.dashboard.root, icon: ICONS.dashboard }],
  },
  /**
   * Management
   */
  {
    subheader: 'Management',
    items: [
      {
        title: 'Schools',
        path: paths.dashboard.schools.root,
        icon: ICONS.course,
        children: [
          { title: 'List', path: paths.dashboard.schools.list },
          { title: 'Create', path: paths.dashboard.schools.create },
        ],
      },
      {
        title: 'Districts',
        path: paths.dashboard.districts.root,
        icon: ICONS.banking,
        children: [
          { title: 'List', path: paths.dashboard.districts.list },
          { title: 'Create', path: paths.dashboard.districts.create },
        ],
      },
      {
        title: 'Users',
        path: paths.dashboard.users.root,
        icon: ICONS.user,
        children: [
          { title: 'List', path: paths.dashboard.users.list },
          { title: 'Create', path: paths.dashboard.users.create },
        ],
      },
      {
        title: 'Access',
        path: paths.dashboard.access.root,
        icon: ICONS.lock,
        children: [{ title: 'Permission Groups', path: paths.dashboard.access.groups }],
      },
    ],
  },
];
